import React from 'react';

import Localization from "composer/Localization.jsx"

// development variables begin

const UNIT_TEST = false;


const DEBUG = true;

const DEBUG_AUTO_ENTER_LOCALE = false;

const DEBUG_ID = 0;
// development variables end (remove later)

// Google Map API key
const GMAP_KEY = "AIzaSyD4R7a5wKz5A95h1VwkGSTXoViI6Ji5k2s";

// Mapbox API key
const MBOX_KEY = "pk.eyJ1IjoiY2xzdCIsImEiOiJjazl4ajRmOXcwajgxM2Vxc3BxcmFrMGY4In0.1azTvmjcaRNsIUwi8TrinQ";

// Mapbox style
const MBOX_STYLE = {
  ZH: {
    satellite: "mapbox://styles/clst/ckkgh599v0d9p17mp3s7vpupj",
    mono: "mapbox://styles/clst/ckkgi6rnw0e9e17mpmfbs4s2e",
    cartoon: "mapbox://styles/clst/cklaaawu70j1y17peylwlgj81"
  },
  EN: {
    satellite: "mapbox://styles/clst/cklaa2iiy0c9f17rssw4qdfqg",
    mono: "mapbox://styles/clst/cklaa8bar1pld17nr98uvmx8j",
    cartoon: "mapbox://styles/clst/ckcct8dm87f5o1iqhgguk1nqo"
  }
};

// Maximum number of hotspot can be created
const MAX_HOTSPOT_LEN = {
  NORMAL: 15,
  PREMIUM: 50,
};

// Maximum number of component can be created
const MAX_COMPONENET_LEN = {
  NORMAL: 15,
  PREMIUM: 50,
};

// Textfield length
const MAX_TEXT_LEN = {
  NAME: 50,
  CONTENT: 500,
  REVEAL_CODE: 6
};

// Pin SVG path
const pin_path = "M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9C20.1,15.8,20.2,15.8,20.2,15.7z";

// Google Custom Search Engine ID
const CSE_ID = "011803233796410265963:n7hp-9twnda";

// Google Custom Search Engine API key
const CSE_API_KEY = "AIzaSyD4R7a5wKz5A95h1VwkGSTXoViI6Ji5k2s";

// CHANGE before deployment  **************
const HOST_URL = "https://ev-cuhk.net/";

// debug
const API_SUFFIX = "api_v2/";
const API_SUFFIX_DEBUG = "api_v2_20240119_s/";
// release
// const API_SUFFIX = "api/";

// const HOST_URL = "http://ev-cuhk.net/";


const FILE_SERVER_KEY = "9777CAITE4096";

const AGREEMENT_URL = "https://ev-cuhk.net/agreement/current_version.html";

class Config extends React.Component {
  // development functions begin

  static IS_UNIT_TEST(){
    return UNIT_TEST;
  }

  static IS_DEBUG() {
    return DEBUG;
  }

  static IS_DEBUG_AUTO_ENTER_LOCALE() {
    return DEBUG_AUTO_ENTER_LOCALE;
  }

  static DEBUG_LOCALE() {
    return DEBUG_ID;
  }
  // development functions end

  static HOST_URL() {
    return HOST_URL;
  }

  static CLIENT_PATH() {
    return HOST_URL + 'vh_client/';
  }

  static GMAP_KEY(){
    return GMAP_KEY;
  }

  static MBOX_KEY() {
    return MBOX_KEY;
  }

  static MBOX_STYLE(lang="en"){
    if (lang === "en"){
      return MBOX_STYLE.EN;
    }
    return MBOX_STYLE.ZH;
  }

  static MAX_HOTSPOT_LEN(){
    return MAX_HOTSPOT_LEN
  }

  static MAX_COMPONENET_LEN(){
    return MAX_COMPONENET_LEN;
  }

  static MAX_TEXT_LEN(){
    return MAX_TEXT_LEN;
  }

  static getPinPath(){
    return pin_path;
  }

  static CSE_ID() {
    return CSE_ID;
  }

  static CSE_API_KEY() {
    return CSE_API_KEY;
  }

 // CHANGE before deployment  **************
  static API_PATH() {
    if (Config.IS_DEBUG() === true) {
      return HOST_URL + API_SUFFIX_DEBUG;
    }
    else {
      return HOST_URL + API_SUFFIX;
    }
  }

// CHANGE before deployment  **************
  static UPLOAD_PATH() {
    return HOST_URL + 'upload/';
  }

  static UPLOAD_API_PATH() {
    return Config.API_PATH() + 'upload_file.php';
  }

  static FILE_SERVER_KEY() {
    return FILE_SERVER_KEY;
  }

  static validateInput(inputStr) {
    if (inputStr.length === 0 || inputStr === "") {
      return false;
    }
    else {
      return true;
    }
  }

  static AGREEMENT_URL() {
    return AGREEMENT_URL;
  }

  static HOTSPOT_CONTENT_SIMPLE_DESCRIPTION    = 1;
  static HOTSPOT_CONTENT_VOICE_OVER            = 2;
  static HOTSPOT_CONTENT_MOVIECLIP             = 3;
  static HOTSPOT_CONTENT_MC_OF_TEXTS           = 4;
  static HOTSPOT_CONTENT_MC_OF_PICTURES        = 5;
  static HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI     = 6;
  static HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI  = 7;
  static HOTSPOT_CONTENT_QUESTION              = 8;
  static HOTSPOT_CONTENT_FILL_IN_THE_BLANK     = 9;
  static HOTSPOT_CONTENT_FILL_IN_MIND_MAP      = 10;
  static HOTSPOT_CONTENT_TAKE_PHOTO            = 11;
  static HOTSPOT_CONTENT_TABLE_AND_CELL        = 12;
  static HOTSPOT_CONTENT_TAKE_RECORD           = 13;
  static HOTSPOT_CONTENT_TYPE_COUNT            = 14;

  static GET_HOTSPOT_CONTENT_CONFIG(kind) {
    let contentData = [
      {
        // 0
        icon: "",
        title: "",
        description: "",
      },
      {
        // 1 圖文描述
        icon: "art_track",
        title: Localization.strings.SIMPLE_DESCRIPTION,
        description: Localization.strings.SIMPLE_DESCRIPTION_DESCRIPTION,
      },
      {
        // 2 聲音導航
        icon: "record_voice_over",
        title: Localization.strings.VOICE_OVER,
        description: Localization.strings.VOICE_OVER_DESCRIPTION,
      },
      {
        // 3 短片介紹
        icon: "local_movies",
        title: Localization.strings.MOVIECLIP,
        description: Localization.strings.MOVIECLIP_DESCRIPTION,
      },
      {
        // 4 文字選擇題
        icon: "list",
        title: Localization.strings.MC_OF_TEXTS,
        description: Localization.strings.MC_OF_TEXTS_DESCRIPTION,
      },
      {
        // 5 圖片選擇題
        icon: "photo",
        title: Localization.strings.MC_OF_PICTURES,
        description: Localization.strings.MC_OF_PICTURES_DESCRIPTION,
      },
      {
        // 6 文字多項選擇
        icon: "list",
        title: Localization.strings.MC_OF_TEXTS_MULTI,
        description: Localization.strings.MC_OF_TEXTS_MULTI_DESCRIPTION,
      },
      {
        // 7 圖片多項選擇
        icon: "photo_library",
        title: Localization.strings.MC_OF_PICTURES_MULTI,
        description: Localization.strings.MC_OF_PICTURES_MULTI_DESCRIPTION,
      },
      {
        // 8 問題
        icon: "contact_support",
        title: Localization.strings.QUESTION,
        description: Localization.strings.QUESTION_DESCRIPTION,
      },
      {
        // 9 填充
        icon: "text_format",
        title: Localization.strings.FILL_IN_THE_BLANK,
        description: Localization.strings.FILL_IN_THE_BLANK_DESCRIPTION,
      },
      {
        // 10 填充概念題
        icon: "category",
        title: Localization.strings.FILL_IN_MIND_MAP,
        description: Localization.strings.FILL_IN_MIND_MAP_DESCRIPTION,
      },
      {
        // 11 拍照題
        icon: "photo_camera",
        title: Localization.strings.TAKE_PHOTO,
        description: Localization.strings.TAKE_PHOTO_DESCRIPTION,
      },
      {
        // 12 自訂列表
        icon: "table_chart",
        title: Localization.strings.TABLE_AND_CELL,
        description: Localization.strings.TABLE_AND_CELL_DESCRIPTION,
      },
      {
        // 13 錄音或訪問
        icon: "mic",
        title: Localization.strings.TAKE_RECORD,
        description: Localization.strings.TAKE_RECORD_DESCRIPTION,
      },
      {
        // 14
        icon: "",
        title: "",
        description: "",
      },
    ]

    if (kind == null) {
      return contentData;
    }
    else {
      return contentData[kind];
    }
  }
}

export default Config;
